import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { EnvService } from './env.service';

export interface PermisoModel {
  id_permisos?: number;
  nombre: string;
  descripcion: string;
  seccion: string;
  borrado: string;
}

export interface PermisoGet {
  payload: PermisoModel[];
}

@Injectable({
  providedIn: 'root'
})
export class PermisosService {

  constructor(public http: HttpClient, private env: EnvService) { }

  headers = new HttpHeaders().set('Content-Type', 'application/json');

  crear(body): Observable<any> {
    return this.http.post(`${this.env.URL_API}/permiso`, body);
  }
  obtenerTodos(): Observable<any> {
    return this.http.get(`${this.env.URL_API}/permiso`).pipe(catchError(this.handleError));
  }
  obtenerId(id): Observable<any> {
    return this.http.get(`${this.env.URL_API}/permiso/${id}`);
  }
  eliminar(id): Observable<any> {
    return this.http.delete(`${this.env.URL_API}/permiso/${id}`);
  }

  // Error
  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(msg);
  }
}
